import React from 'react';

/**
 * It renders a label with a checkbox shown as a toggle switch
 * @param props - {
 * @returns A label with a span and a div inside of it.
 */
export default function InputToggle(props: {
  children: React.ReactNode;
  checked: boolean;
  onChange: () => void;
}) {
  const { children, checked, onChange } = props;
  return (
    <label className='timer-label'>
      <span className='input-description'>{children}</span>
      <div className='input-container'>
        <input
          type='checkbox'
          className='toggle-input'
          checked={checked}
          onChange={onChange}
        />
        <div className='toggle-fill' />
      </div>
    </label>
  );
}
